import { render, staticRenderFns } from "./zzzwCov.vue?vue&type=template&id=2c71bd94&scoped=true"
import script from "./zzzwCov.vue?vue&type=script&lang=js"
export * from "./zzzwCov.vue?vue&type=script&lang=js"
import style0 from "./zzzwCov.vue?vue&type=style&index=0&id=2c71bd94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c71bd94",
  null
  
)

export default component.exports